<template>
  <div class="home-wrapper">
    <div class="top">
      <projectList @seach="management"></projectList>
    </div>
    <div>
      <iframe
        style="height:1000px;width: 100%;"
        :src="url"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { lxnTest } from "../../api/homepage";
import projectList from "./components/projectList";
export default {
  name: "ibdex",
  components: {
    projectList
  },
  data() {
    return {
      projectFid: "",
      url: "",
      tableauDto: {
        tableauUrlKey:"",
        projectIds:[]
      }
    };
  },

  // created() {
  //   this.management(this.tableauDto.projectIds);
  // },
  methods: {
    management(data) {
      this.tableauDto.tableauUrlKey = this.$route.name
      this.tableauDto.projectIds = data
      lxnTest(this.tableauDto).then(res => {
          this.url = res.data;
        }).catch(error => {
          console.log("tableau error" + this.url);
        });
    }
  },
    watch:{
        "$route":function(to,from){
          const pathName=['paybackRate','tenancyBoard','reserveBoard','checkinRate','channelNewSign','flowBoard','unwindAndRenewalBoard','businessDaily','stockBoadrd'];
          if (pathName.indexOf(to.name) > -1) {
            console.log(to.name);
            this.management(this.tableauDto.projectIds);
          }
        }
    }
};
</script>

<style scoped>
.width {
  width: 270px;
}
.top {
  height: 94px;
  line-height: 94px;
  padding-left: 24px;
  flex: none;
}
.content {
  background: rgba(249, 249, 249, 1);
  padding: 26px 24px;
  flex: auto;
  /*margin-top: 20px;*/
}
.home-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
